import { ReactElement } from "react";
import { Skeleton } from "@mui/material";

const styles = {
  content1: {
    gridColumn: "1 / 1",
    gridRow: "1 / span 1",
  },
  content2: {
    gridColumn: "2 / span 1",
    gridRow: "2 / span 1",
  },
  content3: {
    gridColumn: "3 / span 1",
    gridRow: "3 / span 1",
  },
  content4: {
    gridColumn: "4 / span 1",
    gridRow: "4 / span 1",
  },
  content5: {
    gridColumn: "5 / span 1",
    gridRow: "5 / span 1",
  },
  content6: {
    gridColumn: "6 / span 1",
    gridRow: "6 / span 1",
  },
  content7: {
    gridColumn: "7 / span 1",
    gridRow: "7 / span 1",
  },
  content8: {
    gridColumn: "8 / span 1",
    gridRow: "8 / span 1",
  },
  content9: {
    gridColumn: "9 / span 1",
    gridRow: "9 / span 1",
  },
  content10: {
    gridColumn: "10 / span 1",
    gridRow: "10 / span 1",
  },
  content11: {
    gridColumn: "11 / span 1",
    gridRow: "11 / span 1",
  },
  content12: {
    gridColumn: "12 / span 1",
    gridRow: "12 / span 1",
  }
};

const SkeletonGantt = (): ReactElement => {

  const layout = {
    display: "grid",
    // height: "100vh",
    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr",
    gridTemplateRows: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr",
    gridRowGap: "15px"
  };


  return (
    <div style={layout}>
      <Skeleton variant="rectangular" height={40} style={styles.content1}/>
      <Skeleton variant="rectangular" height={40} style={styles.content2}/>
      <Skeleton variant="rectangular" height={40} style={styles.content3}/>
      <Skeleton variant="rectangular" height={40} style={styles.content4}/>
      <Skeleton variant="rectangular" height={40} style={styles.content5}/>
      <Skeleton variant="rectangular" height={40} style={styles.content6}/>
      <Skeleton variant="rectangular" height={40} style={styles.content7}/>
      <Skeleton variant="rectangular" height={40} style={styles.content8}/>
      <Skeleton variant="rectangular" height={40} style={styles.content9}/>
      <Skeleton variant="rectangular" height={40} style={styles.content10}/>
      <Skeleton variant="rectangular" height={40} style={styles.content11}/>
      <Skeleton variant="rectangular" height={40} style={styles.content12}/>
    </div>
  );
};

export default SkeletonGantt;
